import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { Button } from "~/components/common/button";
import { ContentBody } from "~/components/content/content-body";
import { ContentHeadline } from "~/components/content/content-headline";

import ImagePlaceholder from "./img-placeholder.svg";

export const StyledContentBody = styled(ContentBody)``;

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  font-family: ${fontRobotoCondensed};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  padding-block: 28px 32px;
  padding-inline: 28px;

  color: #000000;

  background-color: #d3dff2;

  border-start-end-radius: 12px;
  border-start-start-radius: 12px;
`;

export const StyledContentHeadline = styled(ContentHeadline)`
  font-weight: 700;
  font-size: 28px;
  line-height: 33px;
`;

export const Heading = styled.div`
  font-weight: 700;
  font-size: 14px;
`;

export const LastUpdatedContainer = styled.div``;
export const LastUpdatedDate = styled.span`
  font-weight: 700;
  font-size: 14px;
`;

export const ContentContainer = styled.div`
  margin-block-start: 2px;
  padding-block: 20px 28px;
  padding-inline: 28px;

  color: #000000;

  background-color: #d3dff2;

  border-end-end-radius: 12px;
  border-end-start-radius: 12px;
`;

export const Content = styled.div`
  display: -webkit-box;

  font-weight: 400;
  font-size: 18px;
  line-height: 23.4px;
  white-space: pre-wrap;
  text-overflow: ellipsis;

  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 20;
  line-clamp: 20; /* stylelint-disable-line property-no-unknown */
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin-block-start: 32px;

  ${props => props.theme.breakpoints.only("homeDesktop")} {
    flex-direction: column;
    gap: 16px;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const ReadFullDailyPulseButton = styled(Button)`
  inline-size: 182px;
  padding-block: 8px;
  padding-inline: 12px;

  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  line-height: 20.8px;

  border-radius: 2px;

  background: #4585ff;
`;

export const PreviousEditions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  color: #4585ff;
  font-weight: 700;
  font-size: 16px;

  cursor: pointer;

  text-decoration-line: underline;
`;

export const PlaceHolderContainer = styled.div``;

export const StyledImagePlaceholder = styled(ImagePlaceholder)``;
